import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

export const MarkdownHr = ({ ...props }) => {
  return React.createElement(`hr`, {
    className: clsx(styles.hr),
    ...props,
  });
};
